import type React from 'react';
import { useNavigate } from 'react-router-dom';
import { DeleteSchemaModal } from './DeleteSchemaModal';
import { useSpecificationsData } from './hooks/useSpecificationsData';
import { SchemaCardGrid } from './SchemaCardGrid';
import styles from './Specifications.module.css';

export const Specifications: React.FC = () => {
  const navigate = useNavigate();
  const {
    activeSpec,
    selectSpec,
    schemas,
    loading,
    showDeleteModal,
    postmanEnvStatus,
    urlCheckStatus,
    handleFileSelect,
    renameSchema,
    openDeleteModal,
    closeDeleteModal,
    confirmDeleteSchema,
  } = useSpecificationsData();

  return (
    <div className={styles.container}>
      <div className={styles.mainSection}>
        <div className={styles.sectionHeader}>
          <div className={styles.titleGroup}>
            <h2 className={styles.title}>Specifications</h2>
            <p className={styles.pageDescription}>Upload and manage OpenAPI specifications or Postman collections</p>
          </div>
          <div className={styles.actionBar}>
            <button
              className={styles.button}
              data-variant="success"
              onClick={() => document.getElementById('file-input')?.click()}
            >
              Upload schema
            </button>
          </div>
        </div>

        <SchemaCardGrid
          schemas={schemas}
          activeSpecId={activeSpec?.id}
          postmanEnvStatus={postmanEnvStatus}
          urlCheckStatus={urlCheckStatus}
          onSelectSpec={selectSpec}
          onConfigure={(schema) => navigate(`/specifications/${schema.id}`)}
          onDelete={openDeleteModal}
          onUploadClick={() => document.getElementById('file-input')?.click()}
          onRename={renameSchema}
        />

        <input
          id="file-input"
          className={styles.hiddenInput}
          type="file"
          multiple
          accept=".json,.yaml,.yml"
          onChange={handleFileSelect}
        />
      </div>

      {showDeleteModal && (
        <DeleteSchemaModal loading={loading} onClose={closeDeleteModal} onConfirm={confirmDeleteSchema} />
      )}
    </div>
  );
};
